import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.error.cause.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, vShow as _vShow, createTextVNode as _createTextVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/imgs/ic_tips.png';

const _withScopeId = n => (_pushScopeId("data-v-af86bed4"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  style: {
    "display": "flex",
    "flex-direction": "column",
    "width": "100%"
  }
};
const _hoisted_2 = {
  key: 0
};
const _hoisted_3 = {
  class: "content__container"
};
const _hoisted_4 = {
  class: "table__container"
};
const _hoisted_5 = {
  class: "header"
};
const _hoisted_6 = {
  key: 0,
  class: "mg-r--10"
};
const _hoisted_7 = {
  class: "mg-r--10"
};

const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {
    "cursor": "pointer"
  },
  src: _imports_0,
  alt: "",
  srcset: ""
}, null, -1));

const _hoisted_9 = ["onClick"];
const _hoisted_10 = {
  style: {
    "margin-bottom": "15px"
  }
};
import TagType from '@/views/common/TagType/index.vue';
import Buttons from '@/components/Buttons/index.vue';
import Check from '../FilmReview/Check/index.vue';
import BatchTable from './components/BatchTable/index.vue';
import RelevanceInfoDialog from '@/components/RelevanceInfoDialog/index.vue';
import { usePageConfig } from '@/utils/useComponentConfig';
import { getItemByProp, fileDownload, debounce, removePropertyOfNull } from '@/utils/tools';
import { useBrandsByUser, useBroadCastList, useGenresList, useVodLanguages } from '@/utils/cacheData';
import { getOperatorNameListApi, getUserByCidApi } from '@/api/authority';
import { provide, nextTick, onMounted } from 'vue';
import { elMessage } from '@/utils';
import { useI18n } from 'vue-i18n';
import { useCommon } from '@/store/useCommon';
import { getCurrentTime } from '@/utils/timeFormat';
import { RELEASE_COLOR_NEW, RELEASE_STATUS_NEW } from '@/assets/config/dicts';
import { getReviewListApi, exportProgramInfoApi, auditStatusApi, releaseStatusApi, getProgramRelationCategoryApi } from '@/api/vodNew';
const __default__ = {
  name: 'FilmMange'
};
export default /*#__PURE__*/_defineComponent({ ...__default__,

  setup(__props) {
    const CheckFilm = defineAsyncComponent(() => import('./components/CheckFilm/index.vue'));
    const {
      t
    } = useI18n();
    const tableRef = ref();
    const resonFormRef = ref();
    const tableWarpRef = ref(null);
    const genresIdOptions = ref([{
      name: t('全部'),
      id: ''
    }]); // 是否为VNO账号

    const isVnoUser = computed(() => useCommon().userData.roles.includes('VNO') || useCommon().userData.roles.includes('VNO_CMS'));
    const TYPE_OPTION = {
      movie: t('单片'),
      tv_series: t('剧集')
    };
    const CODING_STATUS = {
      H264: 'H.264',
      H265: 'H.265'
    };
    const check = reactive({
      visible: false
    });
    const checkFilm = reactive({
      visible: false
    });
    const batchTable = reactive({
      visible: false
    });
    const relevanceInfoDialog = reactive({
      visible: false
    });

    const validatorReason = (rule, value, callback) => {
      if (value && value.trim() == '') {
        return callback(new Error('输入不能为空'));
      }

      callback();
    };

    const data = reactive({
      languageOptions: [],
      detailInfo: {
        id: '',
        programType: ''
      },
      postData: {
        reason: ''
      },
      checked: false,
      ifReturn: false
    });
    const dialogConfig = reactive({
      visible: false,
      action: 'online',
      config: {
        title: '提示'
      },
      confirm: done => {
        if (dialogConfig.action === 'return') {
          returnApproval(done);
        } else if (dialogConfig.action === 'online') {
          releaseStatus(dialogConfig.action, done);
        } else if (dialogConfig.action === 'offline') {
          resonFormRef.value.validate(valid => {
            if (valid) {
              releaseStatus(dialogConfig.action, done, data.postData.reason.trim());
            }
          });
        }
      }
    }); // 搜索查询用额外到的参数

    const searchData = reactive({
      releaseStatus: '',
      categoryIds: [],
      //type: 2,
      sortType: 'desc',
      sortField: 'releaseTime',
      ifContain: false
    });
    const searchConfig = reactive({
      size: {
        sm: 24,
        md: 12,
        lg: 8,
        xl: 6,
        xs: {}
      },
      formList: [{
        label: '品牌',
        prop: 'cid',
        widgetType: 'Select',
        filterable: true,
        placeholder: '请选择品牌',
        labelKey: 'prefixName',
        valueKey: 'cid',
        list: [],
        change: val => {
          searchData.categoryIds = [];
          sessionStorage.setItem('currentCid', val);
          searchConfig.formData.operatingUser = '';
          tableConfig.paginationConfig.page = 1;
          tableRef.value && tableRef.value.commonTableRef.clearSelection();
          getUserByCid({
            cid: val
          });
        },
        controller: () => {
          return useCommon().userData.permissionKey.indexOf('DC_FM_BS') > -1;
        },
        disabled: useCommon().userData.roles.includes('VNO') || useCommon().userData.roles.includes('VNO_CMS')
      }, {
        label: '分类属性',
        prop: 'genres',
        widgetType: 'Select',
        placeholder: '请选择分类属性',
        labelKey: 'name',
        valueKey: 'id',
        loading: false,
        list: genresIdOptions,
        change: val => {
          tableConfig.paginationConfig.page = 1;
          tableRef.value && tableRef.value.commonTableRef.clearSelection();
          getReviewList();
        },
        visibleChange: async isVisible => {
          let nowItem = getItemByProp(searchConfig.formList, 'genres');

          if (isVisible && genresIdOptions.value.length === 1) {
            nowItem.loading = true;
            await getGenres();
            nowItem.loading = false;
          }
        }
      }, {
        label: '语言',
        prop: 'language',
        widgetType: 'Select',
        filterable: true,
        placeholder: '请选择语言',
        valueKey: 'labelValue',
        suffix: true,
        labelWidth: '6.25vw',
        list: [],
        change: val => {
          if (val == '') searchData.ifContain = false;
          tableConfig.paginationConfig.page = 1;
          tableRef.value && tableRef.value.commonTableRef.clearSelection();
          getReviewList();
        }
      }, {
        label: '关键字筛选',
        prop: 'keyword',
        widgetType: 'input',
        placeholder: '请输入关键字'
      }, {
        label: '编码协议',
        prop: 'codingFormat',
        widgetType: 'Select',
        list: [{
          label: t('全部'),
          value: ''
        }, {
          label: 'H.264',
          value: 'H264'
        }, {
          label: 'H.265',
          value: 'H265'
        }],
        change: val => {
          tableConfig.paginationConfig.page = 1;
          tableRef.value && tableRef.value.commonTableRef.clearSelection();
          getReviewList();
        }
      }, {
        label: '类型',
        prop: 'programType',
        widgetType: 'Select',
        placeholder: '请选择类型',
        list: [{
          label: t('单片'),
          value: 'movie'
        }, {
          label: t('剧集'),
          value: 'tv_series'
        }],
        change: val => {
          sessionStorage.setItem('currentProgramType', val);
          searchConfig.formData.genres = '';
          tableConfig.paginationConfig.page = 1;
          tableRef.value && tableRef.value.commonTableRef.clearSelection();
          getGenres();
          getReviewList();
        }
      }, {
        label: '创建时间',
        prop: 'time',
        widgetType: 'date',
        'start-placeholder': t('开始时间'),
        'end-placeholder': t('结束时间'),
        valueFormat: 'YYYY-MM-DD',
        type: 'daterange',
        change: debounce(val => {
          tableConfig.paginationConfig.page = 1;
          tableRef.value && tableRef.value.commonTableRef.clearSelection();
          getReviewList();
        }, 200)
      }, // {
      //   label: '更新时间', prop: 'updateTime', widgetType: 'date',
      //   'start-placeholder': t('开始时间'),
      //   'end-placeholder': t('结束时间'),
      //   valueFormat: 'YYYY-MM-DD',
      //   type: 'daterange',
      //   change: debounce((val) => {
      //     tableConfig.paginationConfig.page = 1;
      //     tableRef.value && tableRef.value.commonTableRef.clearSelection();
      //     getReviewList();
      //   }, 200)
      // },
      {
        label: '操作用户',
        prop: 'operatingUser',
        widgetType: 'Select',
        filterable: true,
        placeholder: '',
        labelKey: 'name',
        valueKey: 'id',
        list: [{
          name: t('全部'),
          id: ''
        }],
        controller: () => {
          return useCommon().userData.permissionKey.indexOf('DC_OU') > -1;
        },
        change: val => {
          tableConfig.paginationConfig.page = 1;
          tableRef.value && tableRef.value.commonTableRef.clearSelection();
          getReviewList();
        }
      }, {
        label: '运营商',
        prop: 'cpspId',
        widgetType: 'treeSelect',
        list: [],
        // clearable: true,
        filterable: true,
        controller: () => {
          return useCommon().userData.permissionKey.indexOf('DC_CPSPID_S') > -1;
        },
        change: val => {
          sessionStorage.setItem('currentCpspid', val);
          tableConfig.paginationConfig.page = 1;
          tableRef.value && tableRef.value.commonTableRef.clearSelection();
          getReviewList();
        }
      }, {
        label: '剧集状态',
        prop: 'playReleaseStatus',
        widgetType: 'Select',
        list: [{
          label: '全部',
          value: ''
        }, {
          label: '已上线',
          value: 'online'
        }, {
          label: '已下线',
          value: 'offline'
        }, {
          label: '未上线',
          value: 'not_online'
        }],
        translation: true,
        change: val => {
          tableConfig.paginationConfig.page = 1;
          tableRef.value && tableRef.value.commonTableRef.clearSelection();
          getReviewList();
        },
        controller: () => {
          return useCommon().userData.permissionKey.indexOf('DC_CS_S') > -1;
        }
      }],
      formData: {
        // cid: Number(sessionStorage.getItem('currentCid')),
        cid: null,
        keyword: '',
        genres: '',
        language: '',
        programType: sessionStorage.getItem('currentProgramType') || 'movie',
        time: '',
        updateTime: '',
        codingFormat: '',
        operatingUser: '',
        cpspId: null,
        playReleaseStatus: ''
      }
    });
    const tableConfig = reactive({
      viewLoading: false,
      data: [],
      isCardBlock: true,
      paginationConfig: usePageConfig(),
      isShowHeader: false,
      // scrollbarAlwaysOn: true,
      headerButtonsList: [{
        label: '导出',
        func: () => {
          exportData();
        }
      }, {
        label: '批量操作',
        func: () => {
          const stateArr = selectTableConfig.selectData.map(item => item.releaseStatus);
          const hasSameValue = Array.from(new Set(stateArr)).length === 1;

          if (selectTableConfig.selectData.length === 0) {
            return elMessage('warning', '请先勾选需要批量操作的影片');
          } else if (!hasSameValue) {
            return elMessage('warning', '请先勾选状态相同的影片');
          } else {
            batchTable.visible = true;
          }
        },
        controller: config => {
          config.disabled = !selectTableConfig.selectData.length ? true : false;
          return true;
        }
      }, {
        label: '',
        cellSlot: true,
        func: () => {
          return;
        }
      }],
      // maxHeight: '380px',
      'row-key': row => {
        return row.id;
      }
    });
    const columnConfig = reactive({
      columnList: [{
        label: '',
        prop: '',
        type: 'selection',
        'reserve-selection': true
      }, {
        label: '影片名称',
        prop: 'name',
        width: 260,
        sortable: 'custom'
      }, {
        label: '信息源ID',
        prop: 'sourceId',
        width: 130
      }, {
        label: '类型',
        prop: 'programType',
        width: 100,
        formatter: value => TYPE_OPTION[value]
      }, {
        label: '上线状态',
        prop: 'releaseStatus',
        width: 150,
        sortable: 'custom',
        cellSlot: true
      }, {
        label: '剧集状态',
        prop: 'playReleaseStatus',
        width: 190,
        formatter: val => {
          return `<span class="text-overflow" style="color: ${RELEASE_COLOR_NEW[val]}">
                   ${RELEASE_STATUS_NEW[val] || '--'}</span>`;
        },
        controller: () => {
          return useCommon().userData.permissionKey.indexOf('DC_CS_S') > -1;
        }
      }, {
        label: '语言',
        prop: 'audioLanguage',
        width: 156,
        sortable: 'custom'
      }, {
        label: '编码协议',
        prop: 'videoCode',
        width: 150,
        sortable: 'custom' // formatter: (value: any) => {
        //   if (value) {
        //     let arr = value.split(',');
        //     const res = arr.map(item => CODING_STATUS[Number(item)]);
        //     return res.join();
        //   }
        // }

      }, {
        label: '分类属性',
        prop: 'genres',
        width: 230 //showTooltip: true,

      }, {
        label: '季',
        prop: 'seasons',
        width: 150,
        sortable: 'custom',
        controller: () => {
          return searchConfig.formData.programType === 'tv_series';
        }
      }, {
        label: '关联信息',
        prop: 'info',
        width: 130,
        cellSlot: true,
        controller: () => {
          return useCommon().userData.permissionKey.indexOf('DC_AT') > -1;
        }
      }, {
        label: '操作用户',
        prop: 'operatorName',
        width: 150,
        sortable: 'custom'
      }, {
        label: '创建时间',
        prop: 'createTime',
        width: 190,
        sortable: 'custom',
        formatter: val => val && getCurrentTime(val)
      }, {
        label: '发布时间',
        prop: 'releaseTime',
        width: 190,
        sortable: 'custom',
        formatter: val => val && getCurrentTime(val)
      }, {
        label: '操作',
        prop: '',
        widgetType: 'buttons',
        fixed: 'right',
        width: 260,
        showOverflowTooltip: false,
        buttonsList: [{
          label: '查看',
          func: row => {
            console.log('查看', row);
            const {
              id,
              programType
            } = row;
            data.detailInfo = {
              id,
              programType
            };
            check.visible = true;
          }
        }, {
          label: '上线',
          func: row => {
            const {
              id,
              programType
            } = row;
            auditParams.id = id;
            auditParams.programType = programType;
            dialogConfig.visible = true;
            dialogConfig.action = 'online';
          },
          controller: row => {
            return row.releaseStatus !== 'online' ? true : false;
          }
        }, {
          label: '下线',
          func: row => {
            const {
              id,
              programType
            } = row;
            auditParams.id = id;
            auditParams.programType = programType;
            dialogConfig.visible = true;
            dialogConfig.action = 'offline';
          },
          controller: row => {
            return row.releaseStatus === 'online' ? true : false;
          }
        }, {
          label: '影片',
          func: row => {
            const {
              id,
              programType
            } = row;
            data.detailInfo = {
              id,
              programType
            };
            checkFilm.visible = true;
          }
        }, {
          label: '退回审核',
          func: row => {
            const {
              id,
              programType
            } = row;
            auditParams.id = id;
            auditParams.programType = programType;
            dialogConfig.visible = true;
            dialogConfig.action = 'return';
          },
          controller: row => {
            return row.releaseStatus === 'online' ? false : true;
          }
        }]
      }]
    }); // 单条审核请求数据

    const auditParams = reactive({
      id: '',
      programType: -1
    }); // 上下线

    const releaseStatus = async (action, done, offlineReason) => {
      try {
        let params = {
          programIds: [auditParams.id],
          programType: auditParams.programType,
          releaseStatus: action,
          remark: offlineReason,
          auditStatus: data.ifReturn ? 'return' : undefined
        };
        const res = await releaseStatusApi(params);

        if (res.code == '0') {
          elMessage('success', '操作成功');
          dialogConfig.visible = false;
          getReviewList();
          setTimeout(() => {
            done();
          }, 500);
        } else {
          done();
        }
      } catch (error) {
        done();
      }
    }; // 退回审核


    const returnApproval = async done => {
      try {
        let params = {
          auditStatus: 'return',
          programIds: [auditParams.id],
          programType: auditParams.programType
        };
        const res = await auditStatusApi(params);

        if (res.code == '0') {
          elMessage('success', '操作成功');
          dialogConfig.visible = false;
          getReviewList();
          setTimeout(() => {
            done();
          }, 500);
        } else {
          done();
        }
      } catch (error) {
        done();
      }
    };

    const selectTableConfig = reactive({
      selectData: [] // table已勾选的数据列表

    }); // table复选框点击事件

    const handleSelectionChange = val => {
      selectTableConfig.selectData = val;
    }; // 获取审核数据列表


    const getReviewList = async () => {
      try {
        !tableConfig.viewLoading ? tableConfig.viewLoading = true : '';
        let params = { ...searchData,
          pageNo: tableConfig.paginationConfig.page,
          pageSize: tableConfig.paginationConfig.limit,
          ...searchConfig.formData,
          auditStatus: 'audited' //获取已审核的频道

        };

        if (params.time && params.time.length) {
          params.startTime = params.time[0];
          params.endTime = params.time[1];
          delete params.time;
        }

        const res = await getReviewListApi(removePropertyOfNull(params));

        if (res.code == '0') {
          tableConfig.data = res.data.records ? res.data.records : [];
          tableConfig.paginationConfig.total = res.data.total;
        }

        selectTableConfig.selectData.length && selectTableConfig.selectData.forEach(row => {
          tableRef.value.commonTableRef.toggleRowSelection(row, true);
        });
      } catch (error) {}

      oldGenresList.value = JSON.parse(JSON.stringify(genresList.value));
      tableConfig.viewLoading ? tableConfig.viewLoading = false : '';
    }; // 获取操作用户


    const getUserByCid = async params => {
      try {
        getReviewList();
        const res = await getUserByCidApi(params);

        if (res.code == '0') {
          let item = getItemByProp(searchConfig.formList, 'operatingUser');
          item.list = [{
            name: t('全部'),
            id: ''
          }, ...res.data.sort(function (a, b) {
            return a.name.trim().localeCompare(b.name.trim());
          })];
        }
      } catch (error) {}
    }; // 格式化运营商列表数据


    const formateOperatorOptions = list => {
      let newList = [];
      list.forEach((item, index) => {
        newList.push({
          value: item.id,
          label: item.name,
          children: item.children != null && item.children.length > 0 ? formateOperatorOptions(item.children) : null
        });
      });
      return newList;
    }; // 获取运营商


    const getOperatorList = async () => {
      if (useCommon().userData.permissionKey.indexOf('DC_CPSPID_S') > -1) {
        try {
          const res = await getOperatorNameListApi();

          if (res.code == '0') {
            let item = getItemByProp(searchConfig.formList, 'cpspId');
            item.list = formateOperatorOptions(res.data);
          }
        } catch (error) {}
      }

      let currentCpspid = useCommon().userData.permissionKey.indexOf('DC_CPSPID_S') > -1 ? sessionStorage.getItem('currentCpspid') : useCommon().userData.cpspid || 0;
      searchConfig.formData.cpspId = currentCpspid ? Number(currentCpspid) : useCommon().userData.cpspid || 0;
      sessionStorage.setItem('currentCpspid', String(searchConfig.formData.cpspId));
    }; // 获取品牌选项数据


    const getBrands = async () => {
      try {
        tableConfig.viewLoading = true;
        await getOperatorList();

        if (useCommon().userData.permissionKey.indexOf('DC_FM_BS') > -1) {
          const brands = await useBrandsByUser();
          let searchItem = getItemByProp(searchConfig.formList, 'cid');
          if (searchItem) searchItem.list = brands;
          let cid = sessionStorage.getItem('currentCid');

          if (!cid) {
            sessionStorage.setItem('currentCid', isVnoUser.value ? useCommon().userData.cid[0] : brands[0].cid);
            cid = searchConfig.formData.cid = isVnoUser.value ? useCommon().userData.cid[0] : brands[0].cid;
          } else {
            searchConfig.formData.cid = Number(cid);
          }

          useCommon().userData.permissionKey.indexOf('DC_OU') > -1 ? getUserByCid({
            cid: cid || brands[0].cid
          }) : getReviewList();
        } else {
          let cid = useCommon().userData.cid[0] || 0;
          searchConfig.formData.cid = cid;
          sessionStorage.setItem('currentCid', cid);
          useCommon().userData.permissionKey.indexOf('DC_OU') > -1 ? getUserByCid({
            cid: cid
          }) : getReviewList();
        }
      } catch (error) {
        tableConfig.viewLoading = false;
      }
    };

    onMounted(() => {
      getBrands();
      getBroadCastList();
      getAllLanguages();
    });
    const genresList = ref([]); // 分类属性数据缓存,避免下拉切换造成视图数据影响

    const oldGenresList = ref([]); // 获取分类属性

    const getGenres = async () => {
      const res = await useGenresList(localStorage.getItem('language') || 'en', searchConfig.formData.programType || 0);
      let item = getItemByProp(searchConfig.formList, 'genres');
      item.list = [{
        name: t('全部'),
        id: ''
      }, ...res];
      genresList.value = res;
    };

    provide('genresList', oldGenresList); // 获取所有语言

    const getAllLanguages = async () => {
      const res = await useVodLanguages();
      data.languageOptions = res;
      let languageItem = getItemByProp(searchConfig.formList, 'language');
      languageItem.list = [{
        label: t('全部'),
        value: '',
        labelValue: ''
      }, ...res];
    };

    provide('languageOptions', data.languageOptions);
    const broadCastList = ref([]); // 获取分辨率

    const getBroadCastList = async () => {
      const res = await useBroadCastList();
      broadCastList.value = res;
    };

    provide('broadCastList', broadCastList);
    const Tags = ref([{
      type: '',
      name: '全部'
    }, {
      type: 'online',
      name: '已上线'
    }, {
      type: 'not_online',
      name: '未上线'
    }, {
      type: 'offline',
      name: '已下线'
    }]); // 处理 tags 点击事件

    const handleTagClick = tag => {
      if (searchData.releaseStatus == tag.type) return;
      tableRef.value && tableRef.value.commonTableRef.clearSelection();
      tableConfig.paginationConfig.page = 1;
      searchData.releaseStatus = tag.type;
      getReviewList();
    }; // 搜索查询


    const handleSearch = searchData => {
      tableRef.value && tableRef.value.commonTableRef.clearSelection();
      getReviewList();
    }; // 重置


    const handleReset = () => {
      tableRef.value && tableRef.value.commonTableRef.clearSelection();
      tableRef.value && tableRef.value.commonTableRef.clearSort();
      searchData.ifContain = false;
      searchData.categoryIds = [];
      searchData.sortType = 'desc';
      searchData.sortField = 'releaseTime';
      tableConfig.paginationConfig.page = 1;
      searchConfig.formData = {
        cid: Number(sessionStorage.getItem('currentCid')),
        keyword: '',
        genres: '',
        language: '',
        programType: sessionStorage.getItem('currentProgramType') || 'movie',
        time: '',
        updateTime: '',
        codingFormat: '',
        operatingUser: '',
        cpspId: Number(sessionStorage.getItem('currentCpspid')),
        playReleaseStatus: ''
      };
      getGenres();
      getReviewList();
    }; // 导出


    const exportData = debounce(async () => {
      if (tableConfig.data.length > 0) {
        try {
          tableConfig.viewLoading = true;
          let params = {
            cid: Number(sessionStorage.getItem('currentCid')),
            ...searchData,
            ...searchConfig.formData
          };

          if (selectTableConfig.selectData.length > 0) {
            const ids = selectTableConfig.selectData.map(item => item.id);
            params.idList = ids;
          }

          if (params.time && params.time.length) {
            params.startTime = params.time[0];
            params.endTime = params.time[1];
            delete params.time;
          }

          const res = await exportProgramInfoApi(removePropertyOfNull(params));
          fileDownload(res.data, res.processData.fileName, res.processData.contentType);
          tableRef.value && tableRef.value.commonTableRef.clearSelection();
        } catch (error) {}

        tableConfig.viewLoading = false;
      }
    }, 500);
    watch(() => dialogConfig.visible, val => {
      resonFormRef.value && resonFormRef.value.resetFields();
      data.ifReturn = false;
    });

    const updateList = () => {
      // 清空table复选框选中
      tableRef.value && tableRef.value.commonTableRef.clearSelection();
      getReviewList();
    }; // 表格排序


    const handleSortChange = debounce(async params => {
      if (params.order) {
        const sortType = params.order.replace('ending', '');
        searchData.sortType = sortType;
        searchData.sortField = params.prop;
        getReviewList();
      } else {
        searchData.sortType = '';
        searchData.sortField = '';
        getReviewList();
      }
    }, 300);
    const infoTreeData = ref([]); // 关联信息item点击事件

    const relevanceInfoClick = async row => {
      infoTreeData.value = [];

      try {
        let params = {
          programId: row.id,
          programType: row.programType
        };
        const res = await getProgramRelationCategoryApi(params);

        if (res.code == '0') {
          infoTreeData.value = res.data;
        }
      } catch (error) {}

      relevanceInfoDialog.visible = true;
    };

    const setOptionsBtnColumnWidth = width => {
      const findItem = columnConfig.columnList.find(item => item.label == '操作');
      findItem ? findItem.width = width : '';
    };

    const filterColumnItemChange = () => {
      nextTick(() => {
        tableRef.value && tableRef.value.commonTableRef.doLayout();
      });
    };

    return (_ctx, _cache) => {
      const _component_el_checkbox = _resolveComponent("el-checkbox");

      const _component_search_form = _resolveComponent("search-form");

      const _component_TableColumnOptionBtn = _resolveComponent("TableColumnOptionBtn");

      const _component_el_tooltip = _resolveComponent("el-tooltip");

      const _component_column = _resolveComponent("column");

      const _component_common_table = _resolveComponent("common-table");

      const _component_el_input = _resolveComponent("el-input");

      const _component_el_form_item = _resolveComponent("el-form-item");

      const _component_el_form = _resolveComponent("el-form");

      const _component_MDialog = _resolveComponent("MDialog");

      const _directive_crosswiseScroll = _resolveDirective("crosswiseScroll");

      const _directive_loading = _resolveDirective("loading");

      return _openBlock(), _createElementBlock(_Fragment, null, [_withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_search_form, {
        size: searchConfig.size,
        gutter: 30,
        "form-list": searchConfig.formList,
        "form-data": searchConfig.formData,
        onSearch: handleSearch,
        onReset: handleReset
      }, {
        suffix: _withCtx(scope => [scope.prop == 'language' ? (_openBlock(), _createElementBlock("span", _hoisted_2, [_createVNode(_component_el_checkbox, {
          onChange: _cache[0] || (_cache[0] = () => getReviewList()),
          disabled: searchConfig.formData.language == '',
          modelValue: searchData.ifContain,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => searchData.ifContain = $event),
          label: _unref(t)('不包含')
        }, null, 8, ["disabled", "modelValue", "label"])])) : _createCommentVNode("", true)]),
        _: 1
      }, 8, ["size", "form-list", "form-data"]), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_withDirectives((_openBlock(), _createElementBlock("div", _hoisted_5, [_createVNode(TagType, {
        modelValue: Tags.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => Tags.value = $event),
        onOnTagClick: handleTagClick
      }, null, 8, ["modelValue"]), _createVNode(Buttons, {
        class: "header__btns",
        "buttons-list": tableConfig.headerButtonsList
      }, {
        cellSlot: _withCtx(scope => [_createVNode(_component_TableColumnOptionBtn, {
          "column-list": columnConfig.columnList,
          onFilterColumnItemChange: filterColumnItemChange
        }, null, 8, ["column-list"])]),
        _: 1
      }, 8, ["buttons-list"])])), [[_directive_crosswiseScroll]]), _createElementVNode("div", {
        class: "table-list",
        ref_key: "tableWarpRef",
        ref: tableWarpRef
      }, [_createVNode(_component_common_table, {
        pageSizesConfig: [10, 20, 40, 100, 200],
        dynamicOption: "",
        onSetOptionsBtnColumnWidth: setOptionsBtnColumnWidth,
        ref_key: "tableRef",
        ref: tableRef,
        style: {
          "width": "100%"
        },
        "table-config": tableConfig,
        "pagination-config": tableConfig.paginationConfig,
        render: getReviewList,
        onSelectionChange: handleSelectionChange,
        onSortChange: _unref(handleSortChange)
      }, {
        default: _withCtx(() => [_createVNode(_component_column, {
          "column-list": columnConfig.columnList
        }, {
          title: _withCtx(column => [column.nodeDate.prop == 'playReleaseStatus' ? (_openBlock(), _createElementBlock("span", _hoisted_6, [_createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t(column.label)), 1), _createVNode(_component_el_tooltip, {
            "popper-class": "self-popper",
            placement: "top",
            effect: "light"
          }, {
            default: _withCtx(() => [_hoisted_8]),
            content: _withCtx(() => [_createElementVNode("div", null, _toDisplayString(_ctx.$t('剧集状态已上线提示')), 1), _createElementVNode("div", null, _toDisplayString(_ctx.$t('剧集状态已下线提示')), 1), _createElementVNode("div", null, _toDisplayString(_ctx.$t('剧集状态未上线提示')), 1)]),
            _: 1
          })])) : _createCommentVNode("", true)]),
          cellSlot: _withCtx(scope => [scope.column.property == 'releaseStatus' ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "text-overflow",
            style: _normalizeStyle('color:' + _unref(RELEASE_COLOR_NEW)[scope.row.releaseStatus])
          }, _toDisplayString(_unref(RELEASE_STATUS_NEW)[scope.row.releaseStatus]), 5)) : _createCommentVNode("", true), scope.column.property == 'info' ? (_openBlock(), _createElementBlock("span", {
            key: 1,
            class: "link",
            onClick: $event => relevanceInfoClick(scope.row)
          }, _toDisplayString(_ctx.$t('信息')), 9, _hoisted_9)) : _createCommentVNode("", true)]),
          _: 1
        }, 8, ["column-list"])]),
        _: 1
      }, 8, ["table-config", "pagination-config", "onSortChange"])], 512)])])])), [[_directive_loading, tableConfig.viewLoading], [_vShow, !check.visible && !checkFilm.visible && !batchTable.visible]]), _createVNode(Check, {
        modelValue: check.visible,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => check.visible = $event),
        "detail-info": data.detailInfo,
        showAuditStatus: false,
        "header-title": "查看",
        onUpdateList: updateList
      }, null, 8, ["modelValue", "detail-info"]), _createVNode(BatchTable, {
        modelValue: batchTable.visible,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => batchTable.visible = $event),
        "select-list": selectTableConfig.selectData,
        onUpdateList: updateList,
        "page-limit": tableConfig.paginationConfig.limit
      }, null, 8, ["modelValue", "select-list", "page-limit"]), _createVNode(_unref(CheckFilm), {
        modelValue: checkFilm.visible,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => checkFilm.visible = $event),
        "detail-info": data.detailInfo,
        onUpdateList: updateList
      }, null, 8, ["modelValue", "detail-info"]), _createVNode(RelevanceInfoDialog, {
        modelValue: relevanceInfoDialog.visible,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => relevanceInfoDialog.visible = $event),
        "info-tree-data": infoTreeData.value
      }, null, 8, ["modelValue", "info-tree-data"]), _createVNode(_component_MDialog, {
        autoLoading: "",
        modelValue: dialogConfig.visible,
        "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => dialogConfig.visible = $event),
        nativeConfig: {
          width: '25%'
        },
        dialogConfig: dialogConfig.config,
        onOnConfirm: dialogConfig.confirm
      }, {
        default: _withCtx(() => [_createElementVNode("div", null, [dialogConfig.action === 'online' ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 0
        }, [_createTextVNode(_toDisplayString(_ctx.$t('确认将影片修改为上线吗?')), 1)], 64)) : _createCommentVNode("", true), dialogConfig.action === 'offline' ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 1
        }, [_createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.$t('确认将影片修改为下线吗?')), 1), _createVNode(_component_el_checkbox, {
          modelValue: data.ifReturn,
          "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => data.ifReturn = $event),
          label: _ctx.$t('直接退回审核修改'),
          size: "large"
        }, null, 8, ["modelValue", "label"]), _createVNode(_component_el_form, {
          model: data.postData,
          ref_key: "resonFormRef",
          ref: resonFormRef
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            prop: "reason",
            rules: [{
              validator: validatorReason,
              trigger: 'blur'
            }, {
              max: 100,
              message: _ctx.$t('限制字符数量', {
                num: '100'
              }),
              trigger: 'blur'
            }]
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              style: {
                "width": "100%"
              },
              placeholder: _ctx.$t('请输入下线原因'),
              maxlength: 100,
              modelValue: data.postData.reason,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => data.postData.reason = $event),
              "show-word-limit": "",
              type: "textarea"
            }, null, 8, ["placeholder", "modelValue"])]),
            _: 1
          }, 8, ["rules"])]),
          _: 1
        }, 8, ["model"])], 64)) : _createCommentVNode("", true), dialogConfig.action === 'return' ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 2
        }, [_createTextVNode(_toDisplayString(_ctx.$t('确认将影片修改为退回审核吗?')), 1)], 64)) : _createCommentVNode("", true)])]),
        _: 1
      }, 8, ["modelValue", "dialogConfig", "onOnConfirm"])], 64);
    };
  }

});